import { createActions, createReducer } from "reduxsauce";
import { onChangeFieldValue } from "utils/functions";
import { defaultState } from "./vehicle-dashboard-model";

export const { Types, Creators } = createActions({
  vehicleDashboardShowLoading: [],
  vehicleDashboardHideLoading: [],
  vehicleDashboardFetchRegister: ["vehicleStepStatusDescription", "registers", "totalItems", "averageStay"],
  vehicleDashboardChangeFilterOptionsValue: ["filterOptions", "value"],
  vehicleDashboardResetVehiclesData: [],
  vehicleDashboardShowDrawerViewRegister: [],
  vehicleDashboardHideDrawerViewRegister: [],
  vehicleDashboardShowDrawerViewCheckinRegister: [],
  vehicleDashboardHideDrawerViewCheckinRegister: [],
  vehicleDashboardFetchRegisterAsync: [],
});

export const showLoading = (state = defaultState) => ({
  ...state,
  isLoading: true,
});

export const hideLoading = (state = defaultState) => ({
  ...state,
  isLoading: false,
});

export const fetchRegisters = (state, { vehicleStepStatusDescription, registers, totalItems, averageStay }) => ({
  ...state,
  isLoading: false,
  items: {
    ...state.items,
    [vehicleStepStatusDescription]: {
      totalItems,
      registers,
      averageStay,
    },
  },
});

export const showDrawerViewRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerViewRegisterVehicleDashboard: true,
});

export const hideDrawerViewRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerViewRegisterVehicleDashboard: false,
});

export const showDrawerViewCheckinRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerViewCheckinRegisterVehicleDashboard: true,
});

export const hideDrawerViewCheckinRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerViewCheckinRegisterVehicleDashboard: false,
});

export const changeFilterOptionsValue = (state, { filterOptions, value }) => ({
  ...state,
  filterOptions: onChangeFieldValue(state.filterOptions, filterOptions, value),
});

export const resetVehiclesData = (state = defaultState) => ({
  ...state,
  items: defaultState.items,
});

export default createReducer(defaultState, {
  [Types.VEHICLE_DASHBOARD_SHOW_LOADING]: showLoading,
  [Types.VEHICLE_DASHBOARD_HIDE_LOADING]: hideLoading,
  [Types.VEHICLE_DASHBOARD_FETCH_REGISTER]: fetchRegisters,
  [Types.VEHICLE_DASHBOARD_SHOW_DRAWER_VIEW_REGISTER]: showDrawerViewRegister,
  [Types.VEHICLE_DASHBOARD_HIDE_DRAWER_VIEW_REGISTER]: hideDrawerViewRegister,
  [Types.VEHICLE_DASHBOARD_SHOW_DRAWER_VIEW_CHECKIN_REGISTER]: showDrawerViewCheckinRegister,
  [Types.VEHICLE_DASHBOARD_HIDE_DRAWER_VIEW_CHECKIN_REGISTER]: hideDrawerViewCheckinRegister,
  [Types.VEHICLE_DASHBOARD_CHANGE_FILTER_OPTIONS_VALUE]: changeFilterOptionsValue,
  [Types.VEHICLE_DASHBOARD_RESET_VEHICLES_DATA]: resetVehiclesData,
});
